import * as React from 'react';
import {Grid} from '@material-ui/core';
import Box from "@material-ui/core/Box";
import Help, { IHelp } from '../help/Help';
import { traducirLabel, traducirMessage } from '../../blocks/traductor';
import { PinDropSharp } from '@material-ui/icons';
import { useState,useEffect } from 'react';


export interface Props { 
    esSeleccionable: boolean
    esInternamiento: boolean
    onClick: (intrausa: boolean) => void
    ayuda?: IHelp
    obligatorio: boolean
}

const IntraUSA = ( props :Props) => {
    const [seleccionado, setSeleccionado] = useState(props.esInternamiento);
    let estilos = `pointer card normal-height ${props.obligatorio ? 'selected' : ''}`;
    useEffect(() => {
        if (props.obligatorio) {
            setSeleccionado(true); // Si es obligatorio, siempre true
        } else {
            setSeleccionado(props.esInternamiento);
        }
    }, [props.obligatorio, props.esInternamiento]);


    //const handleClick = () => {
    //    if(props.esSeleccionable){
    //        let checked = !seleccionado; 
    //        setSeleccionado(checked);
    //        props.onClick(checked);
    //    }
    //    else{
    //        props.onClick(true);
    //    }
    //} 

    return (<>
        <Grid container className={estilos} justify="center"
                    style={{ pointerEvents: 'none', cursor: 'default' }}>
            <Grid item xs={3}>
                <Box display="flex" flexDirection="column" alignItems="center"><br />
                    <Box>
                        <img src={"/image/icon-intrausa.png"} alt="icon"/>
                    </Box>
                </Box>
            </Grid>

            <Grid item xs>
                <Box display="flex" flexDirection="column" justifyContent="center"><br />
                    <Box className="title-3">{traducirLabel(346) /* Intra USA */}</Box>
                    <Box className="title-4" flexGrow={1}>{traducirLabel(347) /* Internamiento a Estados Unidos */}</Box>
                </Box>
            </Grid>
            <Grid item xs={1}>
                <Box>
                    <Help comments={traducirMessage(321)} customStyle={{ bottom: "1px", right: "-11px"}} size="small" />
                </Box>
            </Grid>

        </Grid>
    </>)
};

export default IntraUSA;
